module.exports = __webpack_public_path__ + "static/img/image7.2f98e60.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/instruction_images/image7.png
// module id = yw6V
// module chunks = 0